import type { FC } from 'react';

import BellIcon from './icons/bell.svg?react';

/**
 * The bell, with the unread dot sitting over its top-right shoulder.
 *
 * The ring around the dot is drawn in `--bell-ring-color`, which a caller sets to its own background
 * (white when unset), so it reads as a gap cut out of the bell on any surface — a hover fill too.
 */
export const NotificationBellIcon: FC<{ hasUnread: boolean }> = ({ hasUnread }) => (
  <span className="relative inline-flex h-5 w-5 shrink-0">
    <BellIcon width={20} height={20} aria-hidden />
    {hasUnread && (
      <span
        aria-hidden
        className="absolute top-0 left-[9px] h-[11px] w-[11px] rounded-full border-2 border-[color:var(--bell-ring-color,theme(colors.white))] bg-primary-main"
      />
    )}
  </span>
);
